import { Star } from "lucide-react";

/** Reusable star rating. Interactive when onChange is provided, otherwise read-only display. */
export default function StarRating({ value = 0, onChange, size = "h-5 w-5", testId }) {
  const stars = [1, 2, 3, 4, 5];
  const interactive = typeof onChange === "function";
  return (
    <div className="flex items-center gap-1" data-testid={testId}>
      {stars.map((n) => (
        <button
          key={n}
          type="button"
          disabled={!interactive}
          onClick={() => interactive && onChange(n)}
          className={interactive ? "cursor-pointer" : "cursor-default"}
          data-testid={testId ? `${testId}-star-${n}` : undefined}
          aria-label={`${n} star`}
        >
          <Star className={`${size} ${n <= value ? "fill-[#dde165] text-[#dde165]" : "text-[#2B2B2B]/20"}`} />
        </button>
      ))}
    </div>
  );
}
